import { Dialog, DialogContent } from '@material-ui/core';
import { convertFromRaw } from 'draft-js';

import styles from 'forms/styles/common.scss';

function Container({ children }) {
    return (
        <section className={styles.formContainer} data-cy="common"> 
            <div className={styles.form} data-cy="common-children">
                { children }
            </div>
        </section>
    );
}

function FormSection({ headerText, children, hidden = false }) {
    if (hidden) return null;

    return (
        <div className={styles.section} data-cy="common-FormSection">
            <header className={styles.header} data-cy="common-headerText">
                { headerText }
            </header>
            <div className={styles.sectionContent} data-cy="common-children">
                { children }
            </div>
        </div>
    );
}

function DocumentSection({ headerText, children }) {
    return (
        <div className={styles.section} data-cy="common-DocumentSection">
            <header className={styles.header} data-cy="common-headerTexts">
                { headerText }
            </header>
            <div className={styles.documentSectionContent} data-cy="common-childrens">
                { children }
            </div>
        </div>
    );
}

function ActionButton({ onActionClick, actionText }) {
    if (!actionText) {
        return null;
    }

    return (
        <div className={styles.rowSection} data-cy="common-ActionButton">
            <button onClick={onActionClick} className={styles.actionButton} data-cy="common-onActionClick">
                { actionText }
            </button>
        </div>
    );
}

function parseAndEscapeDescription(description) {
    // Escape newline, carriage return and tabular characters from JSON string
    let descriptionData, hasDescription;
    try {
        const escapedDescription = description ? description.replace(/\n/g, '\\n')
            .replace(/\r/g, '\\r')
            .replace(/\t/g, '\\t') : description;
        descriptionData = JSON.parse(escapedDescription);
        hasDescription = convertFromRaw(descriptionData).hasText();
    } catch (error) {
        descriptionData = undefined;
        hasDescription = false;
    }

    return {
        descriptionData,
        hasDescription
    };
}

function DataList({ source = [], getter = (entry) => entry }) {
    return (
        <ul className={styles.dataList} data-cy="common-ul">
            {source.map((entry) => (
                <li className={styles.dataList__entry} data-cy="common-li">{getter(entry)}</li>
            ))}
        </ul>
    );
}

function FormDialog({ open, title, children, onClose }) {
    return (
        <Dialog className={styles.dialogContainer} open={open} onClose={onClose} data-cy="common-FormDialog">
            <div className={styles.dialogTitle}>
                <h2 className={styles.dialogTitle__text} data-cy="common-FormDialogtitle">{title}</h2>
                <i className={styles.dialogTitle__closeBtn} onClick={onClose} data-cy="common-FormDialogclose">close</i>
            </div>
            <DialogContent className={styles.dialogContent} data-cy="common-FormDialogclosechildren">
                {children}
            </DialogContent>
        </Dialog>
    );
}

export {
    Container,
    FormSection,
    DocumentSection,
    ActionButton,
    parseAndEscapeDescription,
    DataList,
    FormDialog,
};
